import React, { useEffect, useRef } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Spinner from "../../../Components/spinner";
import { useNavigate } from "react-router-dom";
import { checkImage, ToggleSwitch } from "../../../helper/ImageFormat";
import { ActionButton } from "../../../helper/ImageFormat";
import CustomPagination from "../../../helper/Pagination";
import dateformate from "../../../helper/DateFormate";

const CategoryTable = ({
   loading,
   categoryData,
   Tableheader,
   currentPage,
   perPage,
   totalPages,
   totalCount,
   handlePageClick,
   handleOnDragEnd,
   HandleshowInHome,
   handleStatusToggle,
   handleEditClick,
   handleDelete,
   selected,
   setSelected,
}) => {
   const navigator = useNavigate();
   const selectAllRef = useRef(null);
   const isAllSelected = categoryData.length > 0 && selected.length === categoryData.length;
   const isIndeterminate = selected.length > 0 && selected.length < categoryData.length;
   useEffect(() => {
      if (selectAllRef.current) {
         selectAllRef.current.indeterminate = isIndeterminate;
      }
   }, [isIndeterminate]);

   const toggleSelectAll = () => {
      setSelected(isAllSelected ? [] : categoryData.map((b) => b.id));
   };

   const toggleSelectOne = (id) => {
      setSelected((prev) =>
         prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
      );
   };


   return (
      <>
         <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="sliders">
               {(provided) => (
                  <div
                     {...provided.droppableProps}
                     ref={provided.innerRef}
                     className="table-responsive"
                  >
                     <table className="custom-table table table-striped" cellSpacing="0" style={{ marginTop: "-5px" }}>
                        <thead>
                           <tr>
                              <th>
                                 <input
                                    type="checkbox"
                                    ref={selectAllRef}
                                    checked={isAllSelected}
                                    onChange={toggleSelectAll}
                                 />
                              </th>
                              {Tableheader.map((item, index) => (
                                 <th className="font-weight-bold text-left" key={index}>
                                    {item}
                                 </th>
                              ))}
                           </tr>
                        </thead>
                        <tbody>
                           {loading ? (
                              <tr>
                                 <td colSpan="12" className="text-center">
                                    <Spinner />
                                 </td>
                              </tr>
                           ) : categoryData.length > 0 ? (
                              categoryData.map((item, index) => (
                                 <Draggable
                                    key={item.id}
                                    draggableId={item.id.toString()}
                                    index={index}
                                 >
                                    {(provided) => (
                                       <tr
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          ref={provided.innerRef}
                                       >
                                          <td>
                                             <input
                                                type="checkbox"
                                                checked={selected.includes(item.id)}
                                                onChange={() => toggleSelectOne(item.id)}
                                             />
                                          </td>

                                          <td >
                                             {item.position}
                                          </td>
                                          <td >
                                          {checkImage(item.image)}
                                          </td>

                                          <td>
                                             <span className="item-name">{item?.name}</span>
                                          </td>
                                          <td >
                                             <button
                                                type="button"
                                                className="count-button1"
                                                onClick={() => navigator("/sub-category", { state: item })}
                                             >
                                                {item._count?.children}
                                             </button>
                                          </td>
                                          <td >
                                             <button
                                                type="button"
                                                className="count-button1"
                                                onClick={() =>
                                                   navigator(`/catalogue/${item?.id}`, { state: item })
                                                }
                                             >
                                                {item._count?.CatalogueCategory}
                                             </button>
                                          </td>

                                          <td >
                                             <button
                                                type="button"
                                                className="count-button1"
                                                onClick={() =>
                                                   navigator(`/products/${item?.id}`, { state: item })
                                                }
                                             >
                                                {item._count?.products}
                                             </button>
                                          </td>
                                          <td>{dateformate(item.updatedAt)}</td>
                                          {/* <td>{dateformate(item.createdAt)}</td> */}

                                          <td >
                                             <ToggleSwitch
                                                data={item}
                                                name="showInFilter"
                                                checked={item?.showInHome}
                                                handleStatusToggle={HandleshowInHome}
                                                module={"Category"}
                                             />
                                          </td>
                                          <td >
                                             <ToggleSwitch
                                                data={item}
                                                name="isActive"
                                                checked={item.isActive}
                                                handleStatusToggle={handleStatusToggle}
                                                module={"Category"}
                                             />
                                          </td>
                                          <td className="text-left">
                                             <ActionButton
                                                data={item}
                                                handleEditClick={handleEditClick}
                                                handleDelete={handleDelete}
                                                module={"Category"}
                                             />
                                          </td>
                                       </tr>
                                    )}
                                 </Draggable>
                              ))
                           ) : (
                              <tr>
                                 <td colSpan="12" className="text-center">
                                    <h4>No data available</h4>
                                 </td>
                              </tr>
                           )}
                           {provided.placeholder}
                        </tbody>
                     </table>
                  </div>
               )}
            </Droppable>
         </DragDropContext>

         {categoryData.length > 0 && (
            <CustomPagination
               currentPage={currentPage}
               totalPages={totalPages}
               onPageChange={handlePageClick}
               perPage={perPage}
               totalCount={totalCount}
            />
         )}
      </>
   );
};

export default CategoryTable;
